<template>
  <div class="preLogin">
    <p class="preLogin-title">{{ $t('该分享需要登录查看') }}</p>
    <p class="preLogin-countdown" v-if="curLang === 'zh'"><span class="seconds">{{ seconds }}</span>秒后跳转至登录页</p>
    <p class="preLogin-countdown" v-if="curLang === 'en'">jump to login page after <span class="seconds">{{ seconds }}</span> seconds</p>
    <div class="preLogin-login" @click="toLogin">{{ $t('去登录') }}</div>
  </div>
</template>

<script>
import coButton from 'components/common/button/index.vue'
import { getLanguage, setLanguage } from 'js/util/util'

export default {
  components: {
    coButton,
  },
  data() {
    return {
      seconds: 5,
    }
  },
  methods: {
    toLogin() {
      window.location.href = `/user/login?deliveryCode=${this.$route.params.neid}`
    },
  },
  computed:{
    curLang() {
      return getLanguage()
    },
  },
  mounted() {
    setInterval(() => {
      if (this.seconds === 0) {
        this.toLogin()
      } else {
        this.seconds -= 1
      }
    }, 1000)
  },
}
</script>

<style lang="less" scoped>
   .preLogin{
     width: 400px;
     height: auto;
     padding: 59px 40px 40px;
     position: absolute;
     top: calc(~"50% - 50px");
     left: 50%;
     transform: translateY(-50%);
     margin-left: -200px;
     box-sizing: border-box;
     background: #fff;
     color:#282E3D;
     box-shadow: 0 2px 8px 0 rgba(0,0,0,.16);
     .preLogin-title{
      font-size: 18px;
      text-align: center;
     }
     .preLogin-countdown{
      margin-top: 19px;
      text-align: center;
      font-size: 14px;
      .seconds{
        font-size: 20px;
        color:#0A64FA;
      }
     }
     .preLogin-login{
       width: 320px;
       height: 44px;
       line-height: 44px;
       margin-top: 43px;
       color: white;
       font-size: 16px;
       background-color: #0A64FA;
       border-radius: 2px;
       text-align: center;
     }
   }
</style>
